import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { SiaTranslatePipe } from '@sia/shared';
import { FilePreviewHandlerComponent } from '../../components/file-preview-handler/file-preview-handler.component';
import { FILE_PREVIEW_CONTEXT, FILE_PREVIEW_PROVIDER } from '../../services/file-preview-provider.interface';
import { FileSystemPreviewProvider } from '../../services/file-system-preview.provider';

/** Payload atteso da chi apre il dialog (es. `sia-input-file`): identifica il file d'archivio da anteprimare. */
export interface SiaFilePreviewDialogData {
  /** Path relativo del file nell'archivio (es. `cartella\sotto\file.pdf`). */
  fileId: string;
  /** Estensione/tipo del file (es. `pdf`, `xlsx`). */
  fileType?: string;
  /** Nome file mostrato in intestazione. */
  fileName: string;
}

/**
 * Wrapper `MatDialog` che apre la gestione anteprime ricca (`sia-file-preview-handler`) a schermo pieno
 * per un file d'archivio, risolvendolo per PATH RELATIVO.
 *
 * Fornisce i token del preview a livello di dialog cosi' che i consumatori esterni (es. `sia-input`) non
 * debbano dipendere staticamente da `@sia/file-system`: viene aperto via dynamic import + `MatDialog`,
 * evitando il ciclo `sia-input <-> sia-file-system`. Il contesto usa `archiveId: signal('')` e
 * `isRelativePath: signal(true)`, coerente con `sia-core-file-system` e con la lettura relativa
 * dell'archivio di default.
 */
@Component({
  selector: 'sia-file-preview-dialog',
  templateUrl: './sia-file-preview-dialog.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FilePreviewHandlerComponent, MatIcon, MatIconButton, MatDialogClose, SiaTranslatePipe],
  providers: [
    { provide: FILE_PREVIEW_PROVIDER, useClass: FileSystemPreviewProvider },
    {
      provide: FILE_PREVIEW_CONTEXT,
      useValue: { archiveId: signal(''), isRelativePath: signal(true) },
    },
  ],
})
export class SiaFilePreviewDialogComponent {
  protected readonly data = inject<SiaFilePreviewDialogData>(MAT_DIALOG_DATA);
}
